import { Authority } from "@/generated/graphql";
import { BankCode } from "@/libs/constants";

export enum BizsolDeleteUserAction {
  Delete,
  ChangeToMemberAndDelete,
  CannotDeleteContractAdmin,
  CannotDeleteAdmin,
  CannotDeleteOwnself,
}

interface canTargetUserBeDeletedArgs {
  isTargetLoggedInUser: boolean;
  bankCode: BankCode;
  isTargetConnectedToBizsol: boolean;
  targetAuthority: Authority;
  isTargetContractAdmin: boolean;
}

// canTargetUserBeDeleted determines for Bizsol banks only, whether a user can be deleted.
// Many of this function's arguments are boolean flags. To avoid accidentally passing
// the wrong argument, we use an object to force the caller to name the arguments.
export function canTargetUserBeDeleted(
  args: canTargetUserBeDeletedArgs
): BizsolDeleteUserAction {
  const {
    bankCode,
    isTargetConnectedToBizsol,
    targetAuthority,
    isTargetLoggedInUser,
    isTargetContractAdmin,
  } = args;

  if (isTargetLoggedInUser) {
    return BizsolDeleteUserAction.CannotDeleteOwnself;
  }

  if (bankCode === BankCode.ShikokuBank) {
    // for shikokubank only:
    // Bizsol連携済みの管理者・契約管理者の場合は一般に変更してから削除する
    // en: If the user is an admin and connected to Bizsol, change to member and then delete
    if (targetAuthority === Authority.Admin && isTargetConnectedToBizsol) {
      return BizsolDeleteUserAction.ChangeToMemberAndDelete;
    }
    return BizsolDeleteUserAction.Delete;
    // shikokubank logic ends here
  }

  // 通常の金融機関と同様に契約管理者・管理者は削除しない
  // en: do not delete contract administrators and administrators as with normal financial institutions

  if (isTargetContractAdmin) {
    return BizsolDeleteUserAction.CannotDeleteContractAdmin;
  }

  if (targetAuthority === Authority.Admin) {
    return BizsolDeleteUserAction.CannotDeleteAdmin;
  }

  return BizsolDeleteUserAction.Delete;
}
